module.exports = __webpack_public_path__ + "img/Skating_1413_2.2c823689.jpg";